import { AnalyticsEvent } from 'src/analytics/types';

// eslint-disable-next-line import/prefer-default-export
export const appSignIn: AnalyticsEvent = {
  event: 'general_app_sign_in',
  category: 'general',
  action: 'app_sign_in',
};
